{
  "familyId": "SPR-SAM-TUSSEN-S",
  "questions": [
    {
      "id": "SPR-SAM-TUSSEN-S-001",
      "familyId": "SPR-SAM-TUSSEN-S",
      "module": "SpellingRegel",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "samenstelling",
      "subSkill": "samenst_tussen_s",
      "questionType": "multiple_choice",
      "question": "Welke spelling is correct?",
      "options": ["dorpsplein", "dorpplein", "dorppen plein", "dorps plein"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {"type": "rule", "showWhen": "wrong", "data": {"title": "Tussen-s", "content": "Bij sommige samenstellingen voeg je een -s toe tussen de twee delen. Dit heet de tussen-s.\n\nTip: spreek het woord hardop uit. Hoor je een -s? Dan schrijf je die ook.\ndorp + plein → dorpsplein (je hoort de s)\nstad + muur → stadsmuur (je hoort de s)", "icon": "lightbulb"}}
      ],
      "conceptId": "tussen_s_basis",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Regel: spreek het woord hardop uit — hoor je een -s? Dan schrijf je die ook. 'Dorpsplein': je hoort duidelijk een -s tussen 'dorp' en 'plein'. Die -s schrijf je: dorpsplein. Samenstellingen schrijf je altijd aan elkaar, dus niet 'dorps plein' of 'dorppen plein'.",
        "solutionSteps": [
          "Herken de samenstelling: dorp + plein",
          "Spreek het hardop uit: je hoort 'dorps-plein'",
          "Schrijf de -s die je hoort: dorpsplein",
          "Aan elkaar schrijven (het is één woord)"
        ],
        "distractorExplanations": {
          "0": "Goed! Dorp + s + plein = dorpsplein. Je hoort de -s als je het uitspreekt.",
          "1": "Je bent de tussen-s vergeten. Spreek het hardop uit: je hoort 'dorps-plein', niet 'dorp-plein'. Schrijf de -s die je hoort.",
          "2": "Je hebt het woord gesplitst en 'dorppen' geschreven. Maar het is één woord: dorpsplein. Samenstellingen schrijf je aan elkaar.",
          "3": "Je hebt de tussen-s wel, maar het woord gesplitst. Samenstellingen schrijf je aan elkaar: dorpsplein, niet 'dorps plein'."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "spr.linking-s-forgotten", "label": "Tussen-s vergeten", "optionIndex": 1 },
          { "id": "spr.compound-split", "label": "Samenstelling gesplitst + vervormd", "optionIndex": 2 },
          { "id": "spr.compound-split", "label": "Samenstelling los geschreven", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-SAM-TUSSEN-S-002",
      "familyId": "SPR-SAM-TUSSEN-S",
      "module": "SpellingRegel",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "samenstelling",
      "subSkill": "samenst_tussen_s",
      "questionType": "multiple_choice",
      "question": "Welk woord heeft een tussen-s?",
      "options": ["boekenkast", "pannenlap", "koningshuis", "fietsenrek"],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        {"type": "rule", "showWhen": "wrong", "data": {"title": "Tussen-s of tussen-en?", "content": "Sommige samenstellingen hebben een tussen-s, andere een tussen-en.\n\nTussen-s: koningshuis, dorpsplein, stadsmuur\nTussen-en: boekenkast, pannenlap, fietsenrek\n\nTip: spreek het woord uit. Hoor je -s of -en? Schrijf wat je hoort.", "icon": "lightbulb"}}
      ],
      "conceptId": "tussen_s_herkennen",
      "variantIndex": 2,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Koningshuis heeft een tussen-s: koning + s + huis. Spreek het uit: 'konings-huis'. De andere woorden hebben een tussen-en: boeken-kast, pannen-lap, fietsen-rek. Tip: luister goed naar wat je hoort tussen de twee delen.",
        "solutionSteps": [
          "Koningshuis: koning + s + huis (je hoort -s)",
          "Boekenkast: boek + en + kast (je hoort -en)",
          "Pannenlap: pan + en + lap (je hoort -en)",
          "Fietsenrek: fiets + en + rek (je hoort -en)"
        ],
        "distractorExplanations": {
          "0": "Boekenkast heeft een tussen-en, niet een tussen-s. Spreek het uit: boeken-kast. Je hoort -en, niet -s.",
          "1": "Pannenlap heeft een tussen-en: pannen-lap. Je hoort -en, niet -s.",
          "2": "Goed! Koningshuis heeft een tussen-s: konings + huis.",
          "3": "Fietsenrek heeft een tussen-en: fietsen-rek. Je hoort -en, niet -s."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.linking-s-confused-en", "label": "Tussen-en verward met tussen-s", "optionIndex": 0 },
          { "id": "spr.linking-s-confused-en", "label": "Tussen-en verward met tussen-s", "optionIndex": 1 },
          { "id": "spr.linking-s-confused-en", "label": "Tussen-en verward met tussen-s", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-SAM-TUSSEN-S-003",
      "familyId": "SPR-SAM-TUSSEN-S",
      "module": "SpellingRegel",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "samenstelling",
      "subSkill": "samenst_tussen_s",
      "questionType": "multiple_choice",
      "question": "Welke spelling is FOUT?",
      "options": ["schaapskooi", "schaapherder", "stadsmuur", "landbouwgrond"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {"type": "rule", "showWhen": "wrong", "data": {"title": "Schaap + s", "content": "Bij 'schaap' hoor je een -s in samenstellingen: schaaps-herder, schaaps-kooi.\n\nSpreek het hardop uit: 'schaapherder' klinkt onhandig, 'schaapsherder' klinkt natuurlijk. Schrijf de -s die je hoort.", "icon": "lightbulb"}}
      ],
      "conceptId": "tussen_s_fout",
      "variantIndex": 3,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "'Schaapherder' mist de tussen-s. Spreek het hardop uit: je hoort 'schaaps-herder', niet 'schaap-herder'. Het moet 'schaapsherder' zijn. De andere woorden zijn correct: schaapskooi, stadsmuur, landbouwgrond.",
        "solutionSteps": [
          "Spreek elk woord hardop uit",
          "Schaapherder → klinkt onhandig, mist de -s",
          "Correct: schaapsherder",
          "De andere woorden klinken goed zoals ze zijn"
        ],
        "distractorExplanations": {
          "0": "Schaapskooi is correct — met tussen-s. De fout zit in 'schaapherder' (mist de -s).",
          "1": "Goed gevonden! 'Schaapherder' moet 'schaapsherder' zijn — met tussen-s.",
          "2": "Stadsmuur is correct: stad + s + muur. De fout zit in 'schaapherder'.",
          "3": "Landbouwgrond is correct: landbouw + grond (geen verbindingsklank nodig). De fout zit in 'schaapherder'."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.linking-s-forgotten", "label": "Correct woord als fout gezien", "optionIndex": 0 },
          { "id": "spr.linking-s-forgotten", "label": "Correct woord als fout gezien", "optionIndex": 2 },
          { "id": "spr.linking-s-forgotten", "label": "Correct woord als fout gezien", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-SAM-TUSSEN-S-004",
      "familyId": "SPR-SAM-TUSSEN-S",
      "module": "SpellingRegel",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "samenstelling",
      "subSkill": "samenst_tussen_s",
      "questionType": "multiple_choice",
      "question": "Welke samenstelling is correct geschreven?",
      "options": ["arbeidtijd", "arbeids tijd", "arbeid-tijd", "arbeidstijd"],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        {"type": "rule", "showWhen": "wrong", "data": {"title": "Tussen-s bij lange woorden", "content": "Bij langere woorden hoor je vaak een -s als verbinding:\narbeid + s + tijd = arbeidstijd\noverheid + s + beleid = overheidsbeleid\n\nSpreek het uit en schrijf wat je hoort. Samenstellingen schrijf je aan elkaar.", "icon": "lightbulb"}}
      ],
      "conceptId": "tussen_s_uitgang",
      "variantIndex": 4,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Spreek het uit: 'arbeids-tijd'. Je hoort een -s tussen 'arbeid' en 'tijd'. Schrijf die -s: arbeidstijd. Het woord wordt aan elkaar geschreven — geen spatie of streepje.",
        "solutionSteps": [
          "Spreek het uit: arbeids-tijd (je hoort -s)",
          "Schrijf de -s: arbeidstijd",
          "Aan elkaar (het is één woord)"
        ],
        "distractorExplanations": {
          "0": "Je bent de tussen-s vergeten. Spreek het uit: je hoort 'arbeids-tijd', niet 'arbeid-tijd'.",
          "1": "Samenstellingen schrijf je aan elkaar, niet los. Het is 'arbeidstijd', niet 'arbeids tijd'.",
          "2": "Een streepje is hier niet nodig. Samenstellingen schrijf je aan elkaar: arbeidstijd.",
          "3": "Goed! Arbeidstijd — met tussen-s, aan elkaar geschreven."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "spr.linking-s-forgotten", "label": "Tussen-s vergeten", "optionIndex": 0 },
          { "id": "spr.compound-split", "label": "Samenstelling los geschreven", "optionIndex": 1 },
          { "id": "spr.compound-split", "label": "Koppelteken i.p.v. aan elkaar", "optionIndex": 2 }
        ]
      }
    },
    {
      "id": "SPR-SAM-TUSSEN-S-005",
      "familyId": "SPR-SAM-TUSSEN-S",
      "module": "SpellingRegel",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "samenstelling",
      "subSkill": "samenst_tussen_s",
      "questionType": "fill_in",
      "question": "Maak een samenstelling van 'stad' en 'park'. Typ het hele woord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["stadspark"],
        "caseSensitive": false,
        "placeholder": "typ het woord"
      },
      "stimulusAids": [],
      "supportAids": [
        {"type": "rule", "showWhen": "wrong", "data": {"title": "Stad + s + park", "content": "Spreek het uit: 'stads-park'. Je hoort een -s. Schrijf die -s: stadspark.\n\nAndere voorbeelden: stadsmuur, stadscentrum, stadsbus.", "icon": "lightbulb"}}
      ],
      "conceptId": "tussen_s_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Spreek het uit: 'stads-park'. Je hoort een -s tussen 'stad' en 'park'. Schrijf die -s: stadspark. Andere voorbeelden met stad: stadsmuur, stadscentrum.",
        "solutionSteps": [
          "Spreek het uit: stads-park",
          "Je hoort een -s",
          "Schrijf: stadspark"
        ]
      }
    },
    {
      "id": "SPR-SAM-TUSSEN-S-006",
      "familyId": "SPR-SAM-TUSSEN-S",
      "module": "SpellingRegel",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "samenstelling",
      "subSkill": "samenst_tussen_s",
      "questionType": "error_spotting",
      "question": "Zoek de spelfout in deze tekst en verbeter het woord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "De koningkroon lag in een vitrine in het stadsmuseum. Bezoekers mochten er alleen naar kijken.",
        "errors": [
          {
            "word": "koningkroon",
            "position": 1,
            "correction": "koningskroon",
            "explanation": "Koning + kroon: spreek het uit — je hoort 'konings-kroon'. De tussen-s ontbreekt."
          }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Tussen-s", "content": "Bij sommige samenstellingen hoor je een -s tussen de twee delen. Spreek het hardop uit: 'koningskroon' (je hoort de s). Schrijf de -s die je hoort. Andere voorbeelden: dorpsplein, stadsmuur, arbeidstijd.", "icon": "lightbulb" } }
      ],
      "conceptId": "tussen_s_error_spotting",
      "variantIndex": 6,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "'Koningkroon' mist de tussen-s. Spreek het hardop uit: je hoort 'konings-kroon'. Het moet 'koningskroon' zijn. 'Stadsmuseum' is correct — daar staat de tussen-s al goed.",
        "solutionSteps": [
          "Spreek elk samengesteld woord hardop uit",
          "Koningkroon → klinkt onhandig, mist de -s",
          "Correct: koningskroon (koning + s + kroon)",
          "Stadsmuseum is correct (stad + s + museum) ✓"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-SAM-TUSSEN-S-007",
      "familyId": "SPR-SAM-TUSSEN-S",
      "module": "SpellingRegel",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "samenstelling",
      "subSkill": "samenst_tussen_s",
      "questionType": "categorize",
      "question": "Sorteer deze samenstellingen: welke hebben een tussen-s, welke een tussen-en, en welke geen verbindingsklank?",
      "data": {
        "categories": ["Tussen-s", "Tussen-en", "Geen verbindingsklank"],
        "items": [
          { "text": "dorpsplein", "correctCategory": 0 },
          { "text": "boekenkast", "correctCategory": 1 },
          { "text": "landbouwgrond", "correctCategory": 2 },
          { "text": "koningshuis", "correctCategory": 0 },
          { "text": "fietsenrek", "correctCategory": 1 },
          { "text": "voetbalveld", "correctCategory": 2 }
        ]
      },
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Drie soorten verbindingsklanken", "content": "Tussen-s: dorpsplein, koningshuis, stadsmuur (je hoort een -s).\nTussen-en: boekenkast, fietsenrek, pannenlap (je hoort -en).\nGeen verbindingsklank: landbouwgrond, voetbalveld (je hoort niets extra's).\n\nTip: spreek het woord hardop uit en luister wat je hoort.", "icon": "lightbulb" } }],
      "conceptId": "tussen_s_categorize",
      "variantIndex": 7,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Spreek elk woord hardop uit en luister naar de verbindingsklank. Tussen-s: dorpsplein (dorp-s-plein), koningshuis (koning-s-huis). Tussen-en: boekenkast (boek-en-kast), fietsenrek (fiets-en-rek). Geen verbindingsklank: landbouwgrond (landbouw-grond), voetbalveld (voetbal-veld). De sleutel is hardop uitspreken en luisteren naar wat je hoort tussen de twee delen.",
        "solutionSteps": [
          "Dorpsplein: je hoort -s → tussen-s ✓",
          "Boekenkast: je hoort -en → tussen-en ✓",
          "Landbouwgrond: je hoort niets extra's → geen verbindingsklank ✓",
          "Koningshuis: je hoort -s → tussen-s ✓",
          "Fietsenrek: je hoort -en → tussen-en ✓",
          "Voetbalveld: je hoort niets extra's → geen verbindingsklank ✓"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-SAM-TUSSEN-S-008",
      "familyId": "SPR-SAM-TUSSEN-S",
      "module": "SpellingRegel",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "samenstelling",
      "subSkill": "samenst_tussen_s",
      "questionType": "true_false_series",
      "question": "Beoordeel of elke samenstelling correct gespeld is.",
      "data": {
        "statements": [
          { "text": "'Dorpsplein' is correct gespeld.", "isTrue": true },
          { "text": "'Schaapherder' is correct gespeld.", "isTrue": false },
          { "text": "'Stadsmuur' is correct gespeld.", "isTrue": true },
          { "text": "'Arbeidtijd' is correct gespeld.", "isTrue": false },
          { "text": "'Overheidsbeleid' is correct gespeld.", "isTrue": true }
        ]
      },
      "correctAnswer": [true, false, true, false, true],
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Tussen-s controleren", "content": "Spreek elk woord hardop uit. Hoor je een -s? Dan schrijf je die ook.\n'Schaapherder' → schaaps-herder (mist de -s)\n'Arbeidtijd' → arbeids-tijd (mist de -s)\nDe andere woorden zijn correct.", "icon": "lightbulb" } }],
      "conceptId": "tussen_s_tf_series",
      "variantIndex": 8,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Spreek elk woord hardop uit en luister of je een -s hoort. 'Dorpsplein' (dorp-s-plein) ✓, 'stadsmuur' (stad-s-muur) ✓, 'overheidsbeleid' (overheid-s-beleid) ✓ — deze zijn correct. 'Schaapherder' mist de -s: het moet 'schaapsherder' zijn (schaap-s-herder). 'Arbeidtijd' mist de -s: het moet 'arbeidstijd' zijn (arbeid-s-tijd). Regel: spreek het uit, hoor je -s? Schrijf die dan ook.",
        "solutionSteps": [
          "Dorpsplein: dorp-s-plein → correct ✓",
          "Schaapherder: schaap-herder → mist -s → fout (schaapsherder)",
          "Stadsmuur: stad-s-muur → correct ✓",
          "Arbeidtijd: arbeid-tijd → mist -s → fout (arbeidstijd)",
          "Overheidsbeleid: overheid-s-beleid → correct ✓"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    }
  ]
}